/* eslint-disable */
import 'babel-polyfill';
import Vue from 'vue';
import ShardsVue from 'shards-vue';
import VueGtag from "vue-gtag";
import InstantSearch from "vue-instantsearch";
import moment from 'moment';
import axios from "axios";

// Styles
import 'bootstrap/dist/css/bootstrap.css';
import '@/assets/shards-dashboard-pro/shards-dashboards.scss';
import '@/assets/scss/vue-tags-input.scss';

// Core
import App from './App.vue';
import store from "./store";
import router from './router';
import "./filters";
import "./directives";

// Layouts
import Default from '@/layouts/Default.vue';
import Error400 from '@/components/errors/400.vue';
import Error403 from '@/components/errors/403.vue';
import Error404 from '@/components/errors/404.vue';
import GAuth from '@/config/google_oAuth.js'

const gauthOption = {
  clientId: '137281844-sbrc9b9keud24qjnfco7fr3uskrfqdjp.apps.googleusercontent.com', //137281844-sbrc9b9keud24qjnfco7fr3uskrfqdjp.apps.googleusercontent.com
  scope: 'email',
  prompt: 'select_account',
  pluginName: 'onewwf-search',
};

ShardsVue.install(Vue);


Vue.component('default-layout', Default);
Vue.component('error-400', Error400);
Vue.component('error-403', Error403);
Vue.component('error-404', Error404);
Vue.use(InstantSearch);
Vue.use(GAuth, gauthOption);


Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS },
  pageTrackerTemplate(to) {
    return {
      page_title: document.title,
      page_path: to.path
    }
  },
  bootstrap: false,
}, router);



Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue();
Vue.prototype.moment = moment;
Vue.prototype.$filters = Vue.options.filters;

// Add a request interceptor
axios.interceptors.request.use(function (config) {
  config.headers['x-api-key'] = process.env.VUE_APP_REDIRECT_API_KEY;

  return config;
});




new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
